import piwik from 'piwik/piwik';
import { toast } from 'react-toastify';
import { ProductType } from 'types/Products';
import { SearchDocument } from 'types/Search';
import {
  DeleteBookmark,
  PutBookmark
} from '../../../api/services/BookmarkService';
import { useCallback } from 'react';
import { useLogEvent } from 'api/services/LogEventService';
import { LogEventType } from 'types/LogEvents';
import { useParams } from 'react-router-dom';

export const useBookmark = (onSuccess: () => void) => {
  const { event: eventKey } = useParams();
  const logEvent = useLogEvent();
  const onBookmarkChange = useCallback(
    (product: SearchDocument, isBookmarked: boolean) => {
      if (isBookmarked) {
        DeleteBookmark(product, onSuccess, () => {
          // revert the previous change
          toast.error('Could not remove bookmark!');
        });
      } else {
        PutBookmark(
          product,
          () => {
            if (product.type === ProductType.INGREDIENTS) {
              if (eventKey) {
                piwik.push([
                  'trackEvent',
                  `Bookmarks for ${eventKey}`,
                  `added bookmark for ${eventKey}`,
                  product.name
                ]);
              } else {
                piwik.push(['trackEvent', 'Bookmarks', 'add', product.name]);
              }
            }
            logEvent(
              [
                {
                  productId: product.old_key,
                  segment: product.segment,
                  supplierId: product.company.key
                }
              ],
              product.type === ProductType.INGREDIENTS
                ? LogEventType.BOOKMARK_ADDED
                : product.type === ProductType.FORMULATIONS
                ? LogEventType.FORMULATION_BOOKMARK_ADDED
                : LogEventType.SERVICE_BOOKMARK_ADDED,
              eventKey
            );
          },
          () => {
            // revert the previous change
            toast.error('Could not add bookmark!');
          }
        );
      }
    },
    [onSuccess, eventKey, logEvent]
  );

  return { onBookmarkChange };
};
